import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { distinctUntilChanged } from 'rxjs/operators';
import { SupportedChannelMessageEnum } from './shared/helpers/supported-channel-message.enum';
import { ActivityService } from './shared/services/activity.service';
import { HostChannelService } from './shared/services/host-channel.service';

import { AppState } from './store';
import * as fromAuthActions from './store/auth/actions';

@Component({
  standalone: false,
  selector: 'app-root',
  template: `
    <nb-layout>
      <nb-layout-column>
        <router-outlet></router-outlet>
      </nb-layout-column>
    </nb-layout>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly store: Store<AppState>,
    private readonly activityService: ActivityService,
    private readonly hostChannelService: HostChannelService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.pipe(distinctUntilChanged()).subscribe(params => {
      if (params.initpayload) {
        const init: string = params.initpayload;
        const quick: string[] = params.supportedQuickActions || params.supportedquickactions || [];

        this.store.dispatch(
          fromAuthActions.authenticate({
            initPayload: init,
            supportedQuickActions: quick,
            userIdForAtInternet: params.userIdForAtInternet || '',
          }),
        );
      } /* else {
        const tokenResponse: IdentityProviderMessagingTokenResponse | null =
          this.webStorage.getInSession('tokenResponse');
        if (tokenResponse?.data.participants) {
          this.store.dispatch(fromAuthActions.authenticateSuccess());
          this.store.dispatch(
            fromParticipantsActions.setParticipantList({
              participants: tokenResponse.data.participants,
            }),
          );
        }
      } */
    });

    this.activityService.events$.subscribe(event => {
      if (event) {
        this.hostChannelService.postMessage({
          type: SupportedChannelMessageEnum.HEARTBEAT,
        });
      }
    });
  }
}
